import { render, staticRenderFns } from "./PaymentInstructionCard.vue?vue&type=template&id=1b596c48&scoped=true"
import script from "./PaymentInstructionCard.vue?vue&type=script&lang=js"
export * from "./PaymentInstructionCard.vue?vue&type=script&lang=js"
import style0 from "./PaymentInstructionCard.vue?vue&type=style&index=0&id=1b596c48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b596c48",
  null
  
)

export default component.exports